import { createApi } from "@onestore/onestore-store-common/api"
import vars from "./onestoreVars"

const api = createApi(vars.apiUrl, {
  useSession: vars.isSessionEnabled,
})

export const apiUrl = vars.apiUrl
export default api
